module.exports = __webpack_public_path__ + "img/channel.c0552855.svg";